export { default as PageTabs } from './page-tabs';
